<div class="dashboard-container">
  <!-- My Dashboard Card (Left Side) -->
  <div class="my-dashboard-card">
    <div class="dashboard-content">
      <div class="dashboard-text">
        <h2 class="dashboard-title">{{ "homepage.dashboard.title" | translate }}</h2>
        <p class="dashboard-description">
          {{ "homepage.dashboard.description" | translate }}
        </p>
        <button class="review-button" (click)="navigateToDashboard()">Review</button>
      </div>

      <div class="chart-container">
        <div class="bar-chart">
          <div class="bar bar-1"></div>
          <div class="bar bar-2"></div>
          <div class="bar bar-3"></div>
          <div class="bar bar-4"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Right Column Cards -->
  <div class="right-column">
    @if (accessible(RoleConstants.VIEW_CUSTOMER_COMM_PAGE)) {
    <!-- Program Communications Card -->
    <div class="image-card communications-card" (click)="navigateToCommunications()">
      <img src="assets/images/cors_communication.jpg" class="card-background" alt="Program Communications" />
      <div class="card-overlay"></div>
      <h3 class="large-card-title">
        @for (word of getCoreCommunicationsWords(); track $index) {
        <span>{{ word }}</span>
        }
      </h3>
    </div>
    }

    @if (accessible(RoleConstants.VIEW_CUSTOMER_PROMO_PAGE)) {
    <!-- Educational Material Card -->
    <div class="image-card educational-card" (click)="navigateToPromotions()">
      <img src="assets/images/educational_materials.jpg" class="card-background" alt="Educational Materials" />
      <div class="card-overlay"></div>
      <h3 class="large-card-title">
        @for (word of getEducationalMaterialWords(); track $index) {
        <span>{{ word }}</span>
        }
      </h3>
    </div>
    }
  </div>
</div>

<!-- Body Content Section -->
<div class="body-content-container">
  <!-- Top Section: Manage Events + Request Cards -->
  <div class="body-content-top-section">
    @if (accessible(RoleConstants.VIEW_CUSTOMER_TRAINING_PAGE)) {
    <!-- Manage Events Card -->
    <div class="my-events-card">
      <h2 class="my-events-title">{{ "homepage.myEvents.title" | translate }}</h2>
      <p class="my-events-description">{{ "homepage.myEvents.description" | translate }}</p>
      @if (isEnglishLanguage()) {
      <button class="my-events-view-button" (click)="navigateToEvents()">{{
        "homepage.myEvents.viewButton" | translate
        }}</button>
      }
    </div>
    }

    @if (accessible(RoleConstants.VIEW_CUSTOMER_TRAINING_PAGE) ||
    accessible(RoleConstants.VIEW_CUSTOMER_HEALTH_FAIR_PAGE)) {
    <!-- Request Cards Container -->
    <div class="request-cards-container">
      @if (accessible(RoleConstants.VIEW_CUSTOMER_TRAINING_PAGE)) {
      <!-- Request a Training Card -->
      <div class="request-card" (click)="navigateToTraining()">
        <div class="request-card-content">
          <div class="request-card-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
                stroke="#070F36" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <p class="request-card-text">{{ "homepage.dashboard.requestTraining" | translate }}</p>
        </div>
        <div class="request-card-accent">
          <button class="request-card-plus-button" aria-label="Add Training Request">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 3V13M3 8H13" stroke="#070F36" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>
      }

      @if (accessible(RoleConstants.VIEW_CUSTOMER_HEALTH_FAIR_PAGE)) {
      <!-- Request a Health Fair Card -->
      <div class="request-card" (click)="navigateToHealthFair()">
        <div class="request-card-content">
          <div class="request-card-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 12H18L15 21L9 3L6 12H2" stroke="#070F36" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </div>
          <p class="request-card-text">{{ "homepage.dashboard.requestPromotion" | translate }}</p>
        </div>
        <div class="request-card-accent">
          <button class="request-card-plus-button" aria-label="Add Health Fair Request">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>
      </div>
      }
    </div>
    }
  </div>

  <!-- Helpful Resources Section -->
  <div class="helpful-resources-section">
    <div class="helpful-resources-grid">
      @if (partialFeatureResource.length) {
        @for (resource of partialFeatureResource.slice(0, 4); track resource.nodeId; let i = $index) {
        <div class="helpful-resource-card" (click)="openPromotionalContent(resource)">
          <img class="card-icon" [src]="resource.image" alt="resource icon" />
          <h3 class="card-title">
            {{ resource.text && resource.text.indexOf(':') > -1 ? resource.text.split(':')[0] : resource.text }}
            <span class="sub-title" *ngIf="resource.text && resource.text.indexOf(':') > -1">{{ resource.text.split(':').slice(1).join(':').trim() }}</span>
          </h3>
        </div>
        }
      } @else {
        <div class="helpful-resource-card"></div>
        <div class="helpful-resource-card"></div>
        <div class="helpful-resource-card"></div>
        <div class="helpful-resource-card"></div>
      }
    </div>
  </div>
</div>
